
import { defineComponent, PropType, reactive } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { VacanciesFeedbackT } from '@/core/types/vacancies.types'

// enums
import { FeedbackStatusesT } from '@/core/enums/vacancies.enums'

// realisation
import { vacancies } from '@/core/realisations/vacancies.realisation'

export default defineComponent({
    components: {
        cheap: Cheap,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<VacanciesFeedbackT>,
            default: null,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    emits: ['change-status', 'archive', 'unarchive'],
    setup(props, { emit }) {
        const state = reactive({
            is_archive_loading: false,
        })

        const emitChangeStatus = () => {
            emit('change-status', { status_id: props.item.status_id, feedback_index: props.index })
        }

        const archiveFeedback = async () => {
            try {
                state.is_archive_loading = true
                await vacancies.archiveFeedback(props.item.id)
                emit('archive', props.index)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_archive_loading = false
            }
        }

        const unarchiveFeedback = async () => {
            try {
                state.is_archive_loading = true
                await vacancies.unarchiveFeedback(props.item.id)
                emit('unarchive', props.index)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_archive_loading = false
            }
        }

        return { state, FeedbackStatusesT, emitChangeStatus, archiveFeedback, unarchiveFeedback }
    },
})
